import moment from 'moment'
import type { IntlShape } from 'react-intl'
import type { SelectOptions } from '../types'
import type { ApartmentSelectOptions } from '@viilu-web/shared/types/apartment'
import { bondNameMessage } from '../utils/messages'
import type { Party } from './types'
import { BondName } from '../enum'

export const getPartyRowValue = (
	party: Party,
	key: string,
	apartmentOptions: ApartmentSelectOptions[],
	intl: IntlShape,
	type?: string,
) => {
	const value = party[key]
	switch (type) {
		case 'date':
			const parsedDate = moment(value)
			if (!parsedDate.isValid()) return ''
			return parsedDate.format('DD.MM.YYYY')

		case 'bondName':
			if (party.bonds && party.bonds.length > 0) {
				return party.bonds
					.map((bond) => bondNameMessage(intl, bond.name))
					.join(', ')
			} else return ''

		case 'apartmentOptions':
			const apartmentUUIDs = party.contracts?.map((c) => c.apartmentUUID) ?? []
			const secondaryApartmentUUIDs =
				party.secondaryContracts?.map((c) => c.apartmentUUID) ?? []

			const secondarySet = new Set(secondaryApartmentUUIDs)
			const labelMap = new Map(
				apartmentOptions.map((opt) => [opt.value, opt.label]),
			)

			const allUUIDs = Array.from(
				new Set([...apartmentUUIDs, ...secondaryApartmentUUIDs]),
			)

			if (allUUIDs.length === 0) return '-'

			const secondaryText = intl.formatMessage({
				defaultMessage: 'Toinen maksaja',
				description: 'Label of secondary payer',
			})

			return allUUIDs
				.map((uuid) => {
					const label = labelMap.get(uuid) || '-'
					return secondarySet.has(uuid) ? `${label} (${secondaryText})` : label
				})
				.join(', ')
		default:
			return value
	}
}

export const getBondNameOptions = (intl: IntlShape): SelectOptions[] =>
	Object.values(BondName).map((value) => ({
		label: bondNameMessage(intl, value),
		value: value,
	}))
